/* eslint-disable */
export default {
  BASE_API: process.env.VUE_APP_BASE_API,
  URL_MOTORES: process.env.VUE_APP_URL_MOTORES,
  LOCAL_MOTORES: process.env.VUE_APP_LOCAL_MOTORES,
  USER_STORAGE: process.env.VUE_APP_USER_STORAGE
};
